import { useState } from 'react';
import type { Faq } from '@/types/content';

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openId, setOpenId] = useState<number | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-card border border-background-200 bg-background-50">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-6 md:py-5"
              >
                <span className="text-sm font-medium text-foreground-900 md:text-base">{item.question}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div className="px-4 pb-5 md:px-6">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}